import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1e34d183")

_pushScopeId("data-v-1e34d183")
const _hoisted_1 = { class: "ui__checkPositionCont" }
const _hoisted_2 = { class: "ui__checkPositionCont_title" }
const _hoisted_3 = {
  key: 0,
  class: "ui__checkPositionCont_cont"
}
const _hoisted_4 = { class: "ui__checkPositionCont_item_title" }
const _hoisted_5 = {
  key: 0,
  class: "ui__checkPositionCont_item_desc"
}
const _hoisted_6 = {
  key: 1,
  class: "ui__checkPositionCont_item_imgs"
}
const _hoisted_7 = {
  key: 1,
  class: "ui__checkPositionCont_cont"
}
const _hoisted_8 = { class: "ui__checkPositionCont_item" }
const _hoisted_9 = {
  key: 0,
  class: "ui__checkPositionCont_item_imgs"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _renderSlot(_ctx.$slots, "default"),
    _createVNode("div", _hoisted_2, [
      _createVNode("span", null, _toDisplayString(_ctx.checkPositionContRenderData.checkItemName) + " " + _toDisplayString(_ctx.checkPositionContRenderData.checkItemCode === 'P00P360' ? '(外观)' : ''), 1),
      _createVNode("span", {
        class: ["checkItemStatus", {"cred": _ctx.checkPositionContRenderData.unusual}]
      }, _toDisplayString(_ctx.checkPositionContRenderData.itemDesc), 3)
    ]),
    (_ctx.checkPositionContRenderData.unusual && !_ctx.state.reportMsg.RpCK())
      ? (_openBlock(), _createBlock("div", _hoisted_3, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.checkPositionContRenderData.signRuleVOS, (sign) => {
            return (_openBlock(), _createBlock("div", {
              class: "ui__checkPositionCont_item",
              key: `${_ctx.checkPositionContRenderKey}${sign.congValue}`
            }, [
              _createVNode("p", _hoisted_4, _toDisplayString(sign.congValue), 1),
              (sign.explain)
                ? (_openBlock(), _createBlock("p", _hoisted_5, "解释：" + _toDisplayString(sign.explain), 1))
                : _createCommentVNode("", true),
              (sign.photoList && sign.photoList.length>0)
                ? (_openBlock(), _createBlock("div", _hoisted_6, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(sign.photoList, (photo, index) => {
                      return _withDirectives((_openBlock(), _createBlock("div", {
                        class: "ui__checkPositionCont_item_img",
                        key: `${_ctx.checkPositionContRenderKey}${sign.congValue}${photo.photoIdStr}`
                      }, [
                        _createVNode("img", {
                          onClick: ($event: any) => (_ctx.goToImgView(photo)),
                          src: photo.smallPhotoUrl || photo.photoPath,
                          alt: ""
                        }, null, 8, ["onClick", "src"]),
                        (index === 2 && sign.photoList.length>3)
                          ? (_openBlock(), _createBlock("p", {
                              key: 0,
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goToImgView("all")))
                            }, _toDisplayString(sign.photoList.length) + "张", 1))
                          : _createCommentVNode("", true)
                      ], 512)), [
                        [_vShow, index<=2]
                      ])
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (_ctx.checkPositionContRenderData.unusual && _ctx.state.reportMsg.RpCK() &&
        _ctx.checkPositionContRenderData.photoList && _ctx.checkPositionContRenderData.photoList.length>0)
      ? (_openBlock(), _createBlock("div", _hoisted_7, [
          _createVNode("div", _hoisted_8, [
            (_ctx.checkPositionContRenderData.photoList && _ctx.checkPositionContRenderData.photoList.length>0)
              ? (_openBlock(), _createBlock("div", _hoisted_9, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.checkPositionContRenderData.photoList, (photo, index) => {
                    return _withDirectives((_openBlock(), _createBlock("div", {
                      class: "ui__checkPositionCont_item_img",
                      key: `${_ctx.checkPositionContRenderKey}${photo.photoIdStr}`
                    }, [
                      _createVNode("img", {
                        onClick: ($event: any) => (_ctx.goToImgView(photo)),
                        src: photo.smallPhotoUrl || photo.photoPath,
                        alt: ""
                      }, null, 8, ["onClick", "src"]),
                      (index === 2 && _ctx.checkPositionContRenderData.photoList.length>3)
                        ? (_openBlock(), _createBlock("p", {
                            key: 0,
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.goToImgView("all")))
                          }, _toDisplayString(_ctx.checkPositionContRenderData.photoList.length) + "张", 1))
                        : _createCommentVNode("", true)
                    ], 512)), [
                      [_vShow, index<=2]
                    ])
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
})